import { SelectResults } from "../../modules/booking/router/router";
import { snakeToCamelCase } from "../../utility";
import { mapActions } from "vuex";
import { getDetailsTabRoutes, handleFromRoute } from "../../utility/route";
import { getContactDetailsSelectable } from "../../modules/contacts/router/routes";
import Sidewindow from './sidewindow';
import { childOfOrEqualDetails } from "../../utility/route.js";
import { defaultConfig } from "./config.model";



export const createLDTHost = ({
  entityName = 'contact',
  ldtRoutes = getDetailsTabRoutes(),
  detailsSelectableFunction = getContactDetailsSelectable,
  primaryKey = 'contact_id',
  storeNs = 'DEMO_STORE',
  SELECT_ACTION = 'SELECT_DEMO',
  SELECT_AUTO_ACTION = 'SELECT_DEMO_AUTO',
  listKey = 'list',
}) => {
  const pkCamelCase = snakeToCamelCase(primaryKey);

  const selectFunc = `select${entityName}`;
  const selectAutoFunc = `select${entityName}Auto`;
  const closeDetailsFunc = `close${entityName}Details`;

  return {
    data() {
      return {
        defaultConfig: defaultConfig
      }
    },
    components: {
      Sidewindow,
    },
    watch: {
      '$route': {
        immediate: true,
        handler: function (to, from) {
          const detailsSelectableResult = detailsSelectableFunction(to, from);

          const selectResult = detailsSelectableResult.selectResult;
          const primaryKeyValue = detailsSelectableResult[pkCamelCase];

          // console.log(selectResult);

          switch (selectResult) {
            case SelectResults.SELECT: {
              this[selectFunc](primaryKeyValue);
              break;
            }
            case SelectResults.SELECT_AUTO: {
              this[selectAutoFunc](primaryKeyValue);
              break;
            }
            case SelectResults.CLOSE: {
              // console.log('closed');
              this[closeDetailsFunc]();
              break;
            }
            case SelectResults.IGNORE: {

              break;
            }
          }
        },
      },
    },
    computed: {
      ...(ldtRoutes ? {
        sidewindowFlag: function () {
          return childOfOrEqualDetails(ldtRoutes, this.$route);
        },
      } : {})
    },
    methods: {
      ...mapActions(storeNs, {
        [SELECT_ACTION]: SELECT_ACTION,
        [SELECT_AUTO_ACTION]: SELECT_AUTO_ACTION
      }),
      [selectFunc]: function (primaryKeyValue) {
        console.log('this',this)
        console.log('listKey',listKey)
        console.log('primaryKey',primaryKey)
        console.log('primaryKeyValue',primaryKeyValue)
        console.log('this[listKey]',this[listKey])
        const selectedEntity = this[listKey].find(e => e[primaryKey] == primaryKeyValue);
        if (selectedEntity) {
          this[SELECT_ACTION]({
            flag: true,
            [entityName]: selectedEntity
          });
        } else {
          this[selectAutoFunc](primaryKeyValue);
        }
      },
      [selectAutoFunc]: function (primaryKeyValue) {
        this[SELECT_AUTO_ACTION]({
          flag: true,
          [entityName]: {
            [primaryKey]: primaryKeyValue
          }
        });
      },
      [closeDetailsFunc]: function () {
        // console.log("Log: closeDetailsFunc", closeDetailsFunc)

        this[SELECT_ACTION]({
          flag: false,
        });
      },


      // Sidewindow Functions Conditional on LDTRoutes
      ...(ldtRoutes ? {
        closeSidewindow: function () {
          handleFromRoute(this, () => {
            this.$router.push({ name: ldtRoutes.names.list });
          });
        }
      } : {})
    }
  }
}